import React, { useEffect } from 'react'

import { Route, Switch } from 'react-router-dom'

import { observer } from 'mobx-react'
import EmailBuilder from './EmailBuilder'
import CampaignLinks from './CampaignLinks'
import OnSiteApp from './OnSiteApp'
import WebsiteIntercept from './WebsiteIntercept'
import WebsiteEmbed from './WebsiteEmbed'
import DistributionLandingScreen from './DistributionLandingScreen'

export const DistributeV2 = observer(({ store, distributeStore, surveyId }) => {
    const show = process.env.USE_NEW_DISTRIBUTION
    useEffect(() => {
        if (!show) location.href = `/survey/${surveyId}/setup`
    })

    if (!show) return null

    return (
        <div className="survey-view-wrapper">
            <Switch>
                <Route
                    path="/survey/:surveyId/distributeV2/email"
                    render={({ match, history }) => (
                        <EmailBuilder store={store} distributeStore={distributeStore} match={match} history={history} tab={store.distributeOptions.includes('hasSchedule') ? 'builder' : store.distributeOptions.includes('hasSurveyUser') ? 'lists' : 'builder'} />
                    )}
                />
                <Route
                    path="/survey/:surveyId/distributeV2/campaign"
                    render={({ match, history }) => (
                        <CampaignLinks store={store} distributeStore={distributeStore} match={match} history={history} tab={store.distributeOptions.includes('hasSchedule') ? 'builder' : store.distributeOptions.includes('hasSurveyUser') ? 'lists' : 'builder'} />
                    )}
                />
                <Route
                    path="/survey/:surveyId/distributeV2/onsite"
                    render={({ match, history }) => (
                        <OnSiteApp store={store} distributeStore={distributeStore} match={match} history={history} tab={store.distributeOptions.includes('hasSchedule') ? 'builder' : store.distributeOptions.includes('hasSurveyUser') ? 'lists' : 'builder'} />
                    )}
                />
                <Route
                    path="/survey/:surveyId/distributeV2/intercept"
                    render={({ match, history }) => (
                        <WebsiteIntercept store={store} distributeStore={distributeStore} match={match} history={history} tab={store.distributeOptions.includes('hasSchedule') ? 'builder' : store.distributeOptions.includes('hasSurveyUser') ? 'lists' : 'builder'} />
                    )}
                />
                <Route
                    path="/survey/:surveyId/distributeV2/embed"
                    render={({ match, history }) => (
                        <WebsiteEmbed store={store} distributeStore={distributeStore} match={match} history={history} tab={store.distributeOptions.includes('hasSchedule') ? 'builder' : store.distributeOptions.includes('hasSurveyUser') ? 'lists' : 'builder'} />
                    )}
                />
                <Route
                    path="/survey/:surveyId/distributeV2"
                    render={({ match, history }) => (
                        <DistributionLandingScreen store={store} distributeStore={distributeStore} match={match} history={history} tab={store.distributeOptions.includes('hasSchedule') ? 'builder' : store.distributeOptions.includes('hasSurveyUser') ? 'lists' : 'builder'} />
                    )}
                />
            </Switch>
        </div>
    )
})
